export default "__VITE_ASSET__BKBvJboZ__"